import { Component, OnInit } from '@angular/core';
import { version } from '../../../../package.json';

@Component({
	selector: 'app-footer',
	templateUrl: './footer.component.html',
	styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
	public version: string = version;
	constructor() {}

	/**
	 * @method OnInit
	 */
	ngOnInit(): void {
		//Called after the constructor, initializing input properties, and the first call to ngOnChanges.
		//Add 'implements OnInit' to the class.
	}
}
